import { FC } from 'react'
import { Box, Link } from '@mui/material'
import { AgencyTypeValues } from '../../../../constants/AgencyType'
import { Location } from '../../../../api/models'
import { getPermitRegistrationUrl } from '../../../../utils/permitUtils'

export const AppFormLink: FC<{ location: Location; agencyType: AgencyTypeValues }> = ({ agencyType, location }) => {
  const url = getPermitRegistrationUrl(location, agencyType)

  if (url) {
    return (
      <Link href={url} target={'_blank'} rel="noopener">
        Application Form
      </Link>
    )
  } else {
    return <Box data-testid={'app-form-link-not-available'}>Not available</Box>
  }
}
